import { useQuery } from '@tanstack/react-query'

import { getInitialData } from './auth.service'

export const useInitialData = () =>
  useQuery({
    queryKey: ['initialData'],
    queryFn: getInitialData,
    // Stale time is set to 12 hours so it only refreshes this data once or twice a day, it's not expected to update that often
    staleTime: 12 * 60 * 60 * 1000,
  })
